export const MS_IN_SEC = 1000;
export const TWO_MINUTES_IN_SEC = 120;
export const TWO_DIGITS = 10;
export const TWO_MINUTES = 2;
export const MILLISECONDS_IN_24_HOURS = 24 * 60 * 60 * MS_IN_SEC;
